<section
  class="milkdown-markdown-editor"
  [class.milkdown-markdown-editor--dark]="isDarkMode"
  [class.milkdown-markdown-editor--fullscreen]="isFullscreen"
>
  <header class="milkdown-markdown-editor__heading">
    <p>Markdown 編輯器（Milkdown）</p>
    <span></span>
    <button
      type="button"
      (click)="copyToClipboard()"
      aria-label="複製"
      matTooltip="複製"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.copy"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="pastFromClipboard()"
      aria-label="貼上"
      matTooltip="貼上"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.paste"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="showText()"
      aria-label="顯示原始文字"
      [matTooltip]="showTextFlag() ? '隱藏原始文字' : '顯示原始文字'"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.source"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleDarkMode()"
      aria-label="切換深色模式"
      [matTooltip]="isDarkMode ? '淺色' : '深色'"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="isDarkMode ? markdownToolIcon.sun : markdownToolIcon.moon"
        aria-hidden="true"
      ></span>
    </button>
    <!-- <button type="button" (click)="toggleFullscreen()" aria-label="切換全螢幕" [matTooltip]="isFullscreen ? '離開全螢幕' : '全螢幕'">
      <span class="milkdown-markdown-editor__icon" [innerHTML]="markdownToolIcon.fullscreen" aria-hidden="true"></span>
    </button> -->
  </header>

  <nav
    class="milkdown-markdown-editor__toolbar"
    aria-label="Markdown 編輯工具列"
  >
    <button
      type="button"
      (click)="toggleBold()"
      [disabled]="isDisabled || isReadonly"
      aria-label="粗體"
      matTooltip="粗體"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.bold"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleItalic()"
      [disabled]="isDisabled || isReadonly"
      aria-label="斜體"
      matTooltip="斜體"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.italic"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleStrike()"
      [disabled]="isDisabled || isReadonly"
      aria-label="刪除線"
      matTooltip="刪除線"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.strike"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleHeading(1)"
      [disabled]="isDisabled || isReadonly"
      aria-label="標題一"
      matTooltip="標題一"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.heading1"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleHeading(2)"
      [disabled]="isDisabled || isReadonly"
      aria-label="標題二"
      matTooltip="標題二"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.heading2"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleHeading(3)"
      [disabled]="isDisabled || isReadonly"
      aria-label="標題三"
      matTooltip="標題三"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.heading3"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleBulletList()"
      [disabled]="isDisabled || isReadonly"
      aria-label="項目清單"
      matTooltip="項目清單"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.bulletList"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleOrderedList()"
      [disabled]="isDisabled || isReadonly"
      aria-label="編號清單"
      matTooltip="編號清單"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.orderedList"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="insertTask()"
      [disabled]="isDisabled || isReadonly"
      aria-label="插入工作項目"
      matTooltip="插入工作項目"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.taskList"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleBlockquote()"
      [disabled]="isDisabled || isReadonly"
      aria-label="引用"
      matTooltip="引用"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.blockquote"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="toggleCodeBlock()"
      [disabled]="isDisabled || isReadonly"
      aria-label="程式碼區塊"
      matTooltip="程式碼區塊"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.codeIcon"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="insertTable()"
      [disabled]="isDisabled || isReadonly"
      aria-label="插入表格"
      matTooltip="插入表格"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.table"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="insertLink()"
      [disabled]="isDisabled || isReadonly"
      aria-label="插入連結"
      matTooltip="插入連結"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.link"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="insertImage()"
      [disabled]="isDisabled || isReadonly"
      aria-label="插入圖片"
      matTooltip="插入圖片"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.image"
        aria-hidden="true"
      ></span>
    </button>
    <span class="milkdown-markdown-editor__spacer"></span>
    <button
      type="button"
      (click)="undo()"
      [disabled]="isDisabled || isReadonly"
      aria-label="復原"
      matTooltip="復原"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.undo"
        aria-hidden="true"
      ></span>
    </button>
    <button
      type="button"
      (click)="redo()"
      [disabled]="isDisabled || isReadonly"
      aria-label="重做"
      matTooltip="重做"
    >
      <span
        class="milkdown-markdown-editor__icon"
        [innerHTML]="markdownToolIcon.redo"
        aria-hidden="true"
      ></span>
    </button>
  </nav>

  <div
    class="milkdown-markdown-editor__body"
    [class.milkdown-markdown-editor__body--readonly]="isDisabled || isReadonly"
  >
    <div #editorHost class="milkdown-markdown-editor__host"></div>
  </div>
  @if (showTextFlag()) {
    <mat-divider></mat-divider>
    <textarea [value]="markdown"> </textarea>
  }
</section>
